export default __webpack_public_path__ + "static/media/parking.c7314c7d.svg";